import React from 'react';
import { SwitchContainer, SwitchInput, SwitchLabel, SwitchSlider } from './styles';

export const MaterialSwitch = ({ children, checked, onChange }: {
  children: React.ReactNode,
  checked: boolean,
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}) => {
  return (
    <SwitchContainer>
      <SwitchInput
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <SwitchSlider />
      {children && <SwitchLabel>{children}</SwitchLabel>}
    </SwitchContainer>
  );
};
